<template>
  <div class="vx-row my-5 flex items-center justify-center">
    <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
      <responsive-iframe :src="video" :posterimg="image" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ResponsiveIframe from '@/components/UI/ResponsiveIframe';
export default {
  components: { ResponsiveIframe },
  data() {
    return {};
  },
  props: ['video', 'image'],
};
</script>
